import "./buttons.scss";
import { PlainButton, PlainButtonProps } from "./plain-button";

interface Props extends PlainButtonProps {}

export const BlankButton = ({ children, ...props }: Props) => (
  <PlainButton {...props} className="blank">
    {children}
  </PlainButton>
);
